import { NOTIFICATION_TYPE } from '@yandex-int/k-common/typings';
import { createSelector } from 'reselect';

import { getFirstNotification } from 'common.components/notifications/selectors';
import { getAssignedLessonsCount } from 'common.components/user/selectors';

export const getShouldHideNotification = createSelector(
    [getAssignedLessonsCount, getFirstNotification],
    (assignedLessonsCount, notification): boolean => {
        // EDUCATION-25574: Отключить уведомление о вебинарах (в начале учебного года)
        return notification?.type_slug === NOTIFICATION_TYPE.WEBINAR_INVITATION;

        // EDUCATION-21324: Закрывать баннер о вебинарах для активных пользователей
        // return assignedLessonsCount > 1 && notification?.type_slug === NOTIFICATION_TYPE.WEBINAR_INVITATION;
    }
);
